module.exports = __webpack_public_path__ + "img/caas2m-m@2.062da37b.webp";